<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g transform="translate(-511.25 -644)">
			<path
				d="M18.125,2A13.115,13.115,0,0,0,5,15.125C5,24.969,18.125,39.5,18.125,39.5S31.25,24.969,31.25,15.125A13.115,13.115,0,0,0,18.125,2Zm0,17.812a4.687,4.687,0,1,1,4.688-4.687A4.689,4.689,0,0,1,18.125,19.813Z"
				transform="translate(515.625 645.75)" />
			<path class="a" d="M0,0H45V45H0Z" transform="translate(511.25 644)" />
		</g>
	</svg>
</template>

<script>
	export default {
		name: 'b-icon-location-on',
		components: {},
		computed: {},
		props: {},
	};
</script>

<style scoped lang="scss">
	path.a {
		fill: none;
	}
</style>

<docs>
	IconLocationOn

	```js
	<b-icon-location-on />
	```
</docs>